import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';


class StaffScheduleRequestsChiefAnswer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: false,
      already_answered: false,
      staff: null,
      start: null,
      finish: null,
      reason: null,
      fleet_chief_answer_reason: null,
      justification_opened: false,
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);
    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var self = this;

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    fetch(config.get('api') + '/dados/resposta/chefe/frota/alteracao/escala/' + this.props.match.params.token, { method: 'GET', mode: 'cors', headers: headers }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      self.setState({overlay: {message: '', type: '', status: 'closed'}, message: responseJson.message});
      self.setState({
        already_answered: responseJson.data.already_answered,
        staff: responseJson.data.staff,
        start: responseJson.data.start,
        finish: responseJson.data.finish,
        reason: responseJson.data.reason,
        loaded: true,
      });
      self.handleAlert('', '', 'closed', 'reset');
    }).catch((error) => {
      console.error(error);
    });
  }

  approve() {
    var self = this;
    if (window.confirm(this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.aprovar)) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      var datasave = {
        token: this.props.match.params.token,
        fleet_chief_answer_reason: this.state.fleet_chief_answer_reason,
      };
  
      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      };
      fetch(config.get('api') + '/aprovacao/chefe/frota/alteracao/escala', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({
          already_answered: true,
        });
        this.setState({overlay: {message: 'Solicitação aprovada com sucesso', type: 'success', status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    }
  }


  reprove(event) {
    var self = this;
    if (window.confirm(this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.reprovar)) {
      if(this.state.fleet_chief_answer_reason !== null && this.state.fleet_chief_answer_reason !== '') {
        var datasave = {
          token: this.props.match.params.token,
          fleet_chief_answer_reason: this.state.fleet_chief_answer_reason,
        };
    
        var headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        };
        fetch(config.get('api') + '/reprovacao/chefe/frota/alteracao/escala', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            already_answered: true,
          });
          this.setState({overlay: {message: this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.solicitacaoReprovadaComSucesso, type: 'success', status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      } else {
        this.setState({overlay: {message: this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.eNecessarioPreencherUmaJustificativaParaReprovacao, type: 'warning', status: 'open'}});
      }
    }
  }

  render() {
    var self = this;
    return (
<div className="user-wrapper">
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container-liquid">
      <div className="row">
  			<div className="col-md-8 col-md-offset-2">
          {this.state.loaded === true ?
            <div className="user-content text-center" style={{paddingTop: '20px', border: 'none'}}>
              <div className="row">
                <div className="col-md-4 col-md-offset-4 text-center">
                  <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGVOOS" />
                </div>
              </div>
              <h3>{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.titulo}</h3>
              <hr />
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th className="text-center">{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.tabela.Nome}</th>
                      <th className="text-center">{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.tabela.Inicio}</th>
                      <th className="text-center">{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.tabela.Fim}</th>
                      <th className="text-center">{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.tabela.Justificativa}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">{this.state.staff}</td>
                      <td className="text-center">{this.state.start}</td>
                      <td className="text-center">{this.state.finish}</td>
                      <td className="text-center">{this.state.reason}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              {!this.state.already_answered ?
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <button onClick={() => this.setState({justification_approval: true, justification_reproval: false})} className="btn btn-lg btn-block btn-success"><i className="fa fa-fw fa-check"></i> Estou de acordo</button>
                    </div>
                    <div className="col-md-6">
                      <button onClick={() => this.setState({justification_reproval: true, justification_approval: false})} className="btn btn-lg btn-block btn-danger"><i className="fa fa-fw fa-close"></i> Não estou de acordo</button>
                    </div>
                  </div>
                  {this.state.justification_approval &&
                    <div>
                      <textarea name="fleet_chief_answer_reason" className="form-control" placeholder={this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.placeholder.InstrucoesAoEscalador} value={this.state.fleet_chief_answer_reason} onChange={this.handleChange.bind(this, 'fleet_chief_answer_reason')} style={{ height: '150px'}} />
                      <br />
                      <button onClick={() => this.approve()} className="btn btn-lg btn-block btn-success"><i className="fa fa-fw fa-close"></i> {this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.botaoConfirmarAprovacao}</button>
                    </div>
                  }
                  {this.state.justification_reproval &&
                    <div>
                      <textarea name="fleet_chief_answer_reason" className="form-control" placeholder={this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.placeholder.JustifiqueAReprovacao} value={this.state.fleet_chief_answer_reason} onChange={this.handleChange.bind(this, 'fleet_chief_answer_reason')} style={{ height: '150px'}} />
                      <br />
                      <button onClick={() => this.reprove()} className="btn btn-lg btn-block btn-danger"><i className="fa fa-fw fa-close"></i> {this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.botaoConfirmarReprovacao}</button>
                    </div>
                  }
                </div>
                :
                <p><strong>{this.locale.Solicitacoes.SolicitaçãoDeAlteracaoDeEscala.paragrafoSolicitacaoJaRespondida}</strong></p>
              }
            </div>
          :
          <div className="user-content text-center" style={{paddingTop: '20px', border: 'none'}}>
            <div className="row">
              <div className="col-md-4 col-md-offset-4 text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGVOOS" />
              </div>
            </div>
          </div>
          }
  			</div>
      </div>
		</div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsChiefAnswer;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsChiefAnswer.js